export default "/img/NR.9eb46fe81ed0f3870ed4c959a096af14.png";